import { useQuery, useMutation } from '@tanstack/react-query';
import * as TokenService from '@/services/TokenService';
import type { SendTokensRequest } from '@/types/token';

export const useTokenHistory = () =>
  useQuery({
    queryKey: ['tokens', 'history'],
    queryFn: TokenService.getTokenHistory,
  });

export const useSendTokens = () =>
  useMutation({
    mutationFn: (data: SendTokensRequest) => TokenService.sendTokens(data),
  });
